import { useSuspenseQuery } from "@tanstack/react-query";
import { Suspense } from "react";

import { orpc } from "@/client";
import { ErrorBoundary } from "@/components/error-boundary";
import { Skeleton } from "@/components/ui/skeleton";
import { format } from "@/lib/format";
import { FinanceiroLabels } from "@/lib/labels/financeiro";
import { cn } from "@/lib/utils";

export function BalancesPanel() {
	return (
		<ErrorBoundary>
			<Suspense fallback={<Skeleton className="mt-5 h-24 w-full rounded-lg" />}>
				<BalancesContent />
			</Suspense>
		</ErrorBoundary>
	);
}

function BalancesContent() {
	const { data } = useSuspenseQuery(orpc.financeiro.treasury.accounts.queryOptions());
	const [first] = data.data;
	const single = data.data.length === 1 ? first : undefined;

	if (data.data.length === 0) {
		return null;
	}

	return (
		<section className="surface-panel mt-5">
			<header className="flex flex-wrap items-end justify-between gap-3 p-4">
				<div>
					<p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
						{single === undefined && "Saldo em conta"}
						{single !== undefined && single.name}
					</p>
					<p
						className={cn(
							"mt-2 font-mono text-xl font-semibold sm:text-2xl",
							data.total_cents < 0 ? "text-destructive" : "text-foreground",
						)}
					>
						{FinanceiroLabels.money(data.total_cents)}
					</p>
				</div>
				{data.reported_at !== null && (
					<p className="text-xs text-muted-foreground">
						Saldos bancários informados em {format.dateTime(data.reported_at)}
					</p>
				)}
			</header>

			{single === undefined && (
				<ul className="divide-y divide-border border-t border-border">
					{data.data.map((account) => {
						let detail = "Caixa físico";

						if (account.kind === "bank") {
							detail = FinanceiroLabels.accountDetail(account);
						}

						return (
							<li key={account.id} className="flex items-center justify-between gap-4 px-4 py-3">
								<div className="min-w-0">
									<p className="truncate text-sm font-semibold text-foreground">{account.name}</p>
									{detail.length > 0 && (
										<p className="mt-0.5 text-xs text-muted-foreground">{detail}</p>
									)}
								</div>
								<p
									className={cn(
										"shrink-0 font-mono text-sm font-semibold",
										account.balance_cents !== null && account.balance_cents < 0
											? "text-destructive"
											: "text-foreground",
									)}
								>
									{account.balance_cents === null && "saldo não disponível"}
									{account.balance_cents !== null && FinanceiroLabels.money(account.balance_cents)}
								</p>
							</li>
						);
					})}
				</ul>
			)}
		</section>
	);
}
